import React, { FC } from 'react';
import { Loan } from '../../../interfaces';
import LoanTypeBadge from '../../Common/LoanTypeBadge';
import VerifiedBadge from '../../Common/VerifiedBadge';
import { Link } from 'react-router-dom';

type Props = {
  loan: Loan;
};

export const InvestorLoanCard: FC<Props> = ({ loan }) => {
  return (
    <div className="col-md-6 mb-2 mb-xl-6">
      <div className="card">
        <div className="card-body-slim pb-0">
          <div className="d-flex align-items-center mb-5">
            <div className="d-flex align-items-center flex-grow-1">
              <div className="d-flex flex-column">
                <Link to={`/loan/${loan.id}`}>
                  <span className="text-gray-800 text-capitalize text-hover-primary fs-6 fw-bolder">
                    {loan.title}
                  </span>
                </Link>
                <span className="text-muted fw-bold text-muted d-block fs-8">
                  Submitted by{" "}
                  <span className="text-capitalize">{`${loan.borrower.user.firstname} ${loan.borrower.user.lastname}`}</span>{" "}
                  from{" "}
                  {`${loan.borrower.address_state.name}, ${loan.borrower.address_country.name}`}
                </span>
              </div>
            </div>
          </div>

          <div className="mb-10">
            <LoanTypeBadge id={loan.loan_type_id} /> <VerifiedBadge />
          </div>

          <div className="d-flex justify-content-between g-0 pb-5">
            <div className="mr-8">
              <div className="fs-7 text-muted fw-bold">Amount</div>
              <div className="d-flex align-items-center">
                <div className="fs-5 fw-bolder text-gray-800">
                  {Number.parseInt(loan.amount).toLocaleString("en-US")}
                </div>
              </div>
            </div>
            <div className="">
              <div className="fs-7 text-muted fw-bold">Tenure</div>
              <div className="fs-6 fw-bolder text-gray-800">
                {loan.tenure} months
              </div>
            </div>

            <div className="text-end">
              <Link
                to={`/loan/${loan.id}`}
                className="btn  btn-bg-light btn-active-color-primary btn-sm me-1 text-muted fw-bold"
              >
                view
              </Link>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};
